import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import useDeviceType from "../../../../../custom-hooks/DeviceType";
import EventEHRSwitchButton from "../../../../../component-lib/Molecules/switch-button/EventEHRSwitchButton";
import { TEXT_CONSTANTS } from "../../../../../utils/text-constants/textConstants";
import MenuDropdown from "../../../../../component-lib/Molecules/menuDropdown/MenuDropdown";
import WrapperCard from "../../../../../component-lib/Atoms/card/EventEHRWrapperCard";
import {
  DownloadIcon,
  plusIcon,
  rightDirectionBlackIcon,
  searchIcon,
} from "../../../../../assets";
import Heading from "../../../../../component-lib/Atoms/heading/EventEHRHeading";
import SelectDropdown from "../../../../../component-lib/Atoms/Select/Select";
import SearchSelectDropdown from "../../../../../component-lib/Atoms/SearchSelectDropdown/EventEHRSearchSelectDropdown";
import Button from "../../../../../component-lib/Molecules/button/Button";
import Table from "../../../../../component-lib/Organisms/table/EventEHRTable";
import UsersScreenDialog from "../../../dialogs/UsersScreenDialog";
import {
  addNewFacilityUser,
  getFacilityUserList,
  patchFacilityUser,
  deleteFacilityUser,
  sendFacilityUserInvitation,
  sendFacilityUserBulkInvitation,
} from "../../../../facility-management-screen/FacilityManagementSaga";
import {
  componentKey,
  setCloseUserDialog,
} from "../../../../facility-management-screen/FacilityManagementSlice";
import moment from "moment";
import { formatPhoneNumber } from "../../../../../utils/phoneNumberFormatter";
import ViewUsersDialog from "../../../dialogs/ViewUsersDialog";
import TooltipForTable from "../../../../../component-lib/Molecules/tooltip/TooltipForTable";
import EventEHRConfirmationDialog from "../../../../../component-lib/Molecules/confimation-dialog/EventEHRConfirmationDialog";
import ImportUsersDialog from "../../../dialogs/ImportUsers";
import ImportResultsDialog from "../../../../inventory-screen/dialogs/ImportResultsDialog";
import { importUsersResultsColumns } from "../../../dialogs/importUsersResultsColumns";
import { handleImportData } from "../../../../../utils/handleImportData ";
import FacilityManagementService from "../../../../../services/FacilityManagementService";

const UsersScreen = () => {
  const { facilityUserList, closeUserDialog, facilityList } = useSelector(
    (state: any) => state[componentKey]
  );

  const workLocationData = facilityList?.facilitys?.map((data: any) => ({
    label: data?.name,
    value: data?.id,
  }));

  const location = useLocation();
  const { user } = location.state || {};
  const { User } = useParams();

  const typingTimeoutRef = useRef<NodeJS.Timeout | null>(null);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [rowPerPage, setRowPerPage] = useState("10");
  const [pageNumber, setPageNumber] = useState(1);
  const [searchedValue, setSearchValue] = useState<string>("");
  const [status, setStatus] = useState("");
  const [facilityId, setFacilityId] = useState("");
  const [facilityOptions, setFacilityOptions] = useState<any[]>([]);
  const [defaultUsersDataRow, setDefaultUsersDataRow] = useState<any>({});
  const [openConfirmationDialog, setOpenConfirmationDialog] = useState(false);
  const [selectedUserId, setSelectedUserId] = useState<string | null>(null);

  // BULK SEND-INVITATION SELECTION STATE
  const [selectedRowsForInvite, setSelectedRowsForInvite] = useState<any[]>([]);

  // IMPORT USERS STATE
  const [openImportUsersDialog, setOpenImportUsersDialog] = useState(false);
  const [isImporting, setIsImporting] = useState(false);
  const [importMessage, setImportMessage] = useState<string | null>(null);
  const [openImportResultsDialog, setOpenImportResultsDialog] = useState(false);
  const [importResults, setImportResults] = useState<any>(null);

  // OPEN ADD/EDIT USERS DIALOG
  const [dialogState, setDialogState] = useState<null | "add" | "edit">(null);

  //Data Store For User Provider And Staff data & //OPEN VIEW DIALOG FOR USER AS PROVIDER AND STAFF
  const [openViewUserDialog, setOpenViewUserDialog] = useState(false);

  const selectedFacilityId = workLocationData?.find(
    (data: any) => data?.value === defaultUsersDataRow?.facilityId
  );
  const deviceType = useDeviceType();

  // USERS COLUMN DATA
  const usersColumns = [
    {
      field: "userName",
      label: <div>{user || "User"} Name</div>,
      renderLogic: (row: any) => {
        return <p className="text-neutral-90 font-normal">{row?.userName}</p>;
      },
    },
    {
      field: "departments",
      label: <div>Departments</div>,
      renderLogic: (row: any) => {
        return (
          <p className="text-neutral-90 font-normal">
            <TooltipForTable label={row?.departmentName} />
          </p>
        );
      },
    },
    {
      field: "lastLogin",
      label: <div>Last Login</div>,
      renderLogic: (row: any) => {
        return <p className="text-neutral-90 font-normal">{row?.lastLogin}</p>;
      },
    },
    {
      field: "facilityName",
      label: <div>Facility Name</div>,
      renderLogic: (row: any) => {
        return (
          <p className="text-neutral-90 font-normal">{row?.facilityName}</p>
        );
      },
    },
    {
      field: "contactNumber",
      label: <div>Contact Number</div>,
      renderLogic: (row: any) => {
        return (
          <p className="text-neutral-90 font-normal">{row?.contactNumber}</p>
        );
      },
    },
    {
      field: "email",
      label: <div>Email</div>,
      renderLogic: (row: any) => {
        return <p className="text-neutral-90 font-normal">{row?.email}</p>;
      },
    },
    {
      field: "status",
      label: <div>Status</div>,
      renderLogic: (row: any, index: any) => {
        const status =
          row?.status === "Active"
            ? true
            : row?.status === "InActive"
              ? false
              : false;
        return (
          <div className="text-neutral-90 font-normal flex justify-start gap-1 items-center">
            <EventEHRSwitchButton
              checked={status}
              onChange={() => {
                const payload = {
                  payload: {
                    status: status ? "InActive" : "Active",
                  },
                  id: row?.id,
                };
                dispatch(patchFacilityUser(payload));
              }}
            />
          </div>
        );
      },
    },
    {
      field: "action",
      label: <div>{TEXT_CONSTANTS?.ACTION}</div>,
      renderLogic: (row: any) => {
        return (
          <div className="flex items-center">
            <MenuDropdown
              options={[
                {
                  label: "View Profile",
                  onClickCb: () => handleOpenDialog(row),
                },
                {
                  label: "Edit Profile",
                  onClickCb: () => {
                    setDefaultUsersDataRow(row);
                    setDialogState("edit"); // Open edit dialog
                  },
                },
                {
                  label: "Send Invitation",
                  onClickCb: () => {
                    dispatch(sendFacilityUserInvitation({ id: row?.id }));
                  },
                },
                {
                  label: "Delete User",
                  onClickCb: () => {
                    console.log("Delete button clicked for user:", row?.id);
                    setSelectedUserId(row?.id);
                    setOpenConfirmationDialog(true);
                    console.log("Confirmation dialog should be open now");
                  },
                },
              ]}
            />
          </div>
        );
      },
    },
  ];
  //HANDLE THE VIEW DAILOG AS PROVIDER OR STAFF
  const handleOpenDialog = (row: any) => {
    setDefaultUsersDataRow(row);
    setOpenViewUserDialog(true);
  };

  // HANDLE SEARCH CHANGE VALUE AND ADDED SOME DELAY
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setPageNumber(1);

    const value = e.target.value;

    // CLEAR THE PREVIOUS TIMEOUT
    if (typingTimeoutRef.current) {
      clearTimeout(typingTimeoutRef.current);
    }

    // SET A NEW TIMEOUT TO DELAY THE CALLBACK
    typingTimeoutRef.current = setTimeout(() => {
      setSearchValue(value?.trim());
    }, 500); // ADJUST DELAY AS NEEDED
  };

  // USER LIST ROW DATA
  const usersRowData = facilityUserList?.users?.map((data: any) => ({
    id: data?.id || "-",

    userName: `${data?.firstName || ""} ${data?.lastName || "-"}`,
    lastLogin: data?.lastLogin
      ? moment(data?.lastLogin).format("MM/DD/YYYY [at] HH:mm")
      : "-",
    contactNumber: data?.contactNumber
      ? formatPhoneNumber(data?.contactNumber)
      : "-",
    email: data?.email || "-",
    status: data?.status || "-",

    bsaId: data?.bsaId || "-",
    role: data?.role?.id || "-",
    gender: data?.gender || "-",
    departments: data?.departmentUsers || [],
    departmentName:
      data?.departmentUsers
        ?.map((dept: any) => dept?.department?.name)
        .join(", ") || "-",
    firstName: data?.firstName,
    lastName: data?.lastName,
    facilityId: data?.facilityId || "",
    facilityName: data?.facility?.name,
  }));

  useEffect(() => {
    getUsers();
  }, [searchedValue, rowPerPage, pageNumber, status, facilityId]);

  // Load facility options for the facility filter
  useEffect(() => {
    (async () => {
      try {
        const res = await FacilityManagementService.getFacilityList({
          pageNumber: 1,
          limit: 1000,
        });
        const opts = (res?.data?.facilitys || []).map((f: any) => ({
          label: f?.name,
          value: f?.id,
        }));
        setFacilityOptions(opts);
      } catch (e) {
        // keep default "All Facilities"
      }
    })();
  }, []);

  useEffect(() => {
    if (closeUserDialog) {
      dispatch(setCloseUserDialog(false));
      setDialogState(null);
      getUsers();
      setOpenConfirmationDialog(false); // for delete user confirmation dialog(for api failing scenario)
      setSelectedUserId(null); // Reset selected user ID
    }
  }, [closeUserDialog]);

  // Debug useEffect to monitor state changes
  useEffect(() => {
    console.log(
      "State changed - openConfirmationDialog:",
      openConfirmationDialog,
      "selectedUserId:",
      selectedUserId
    );
  }, [openConfirmationDialog, selectedUserId]);

  const getUsers = () => {
    const payload = {
      name: searchedValue?.trim(),
      pageNumber: pageNumber,
      limit: rowPerPage,
      status: status || "",
      facilityId: facilityId || "",
      type: User === "provider-user" ? "provider" : "staff",
    };
    dispatch(getFacilityUserList(payload));
  };

  const handleImportUsersData = async (
    formData: Record<string, unknown>
  ) => {
    await handleImportData(formData, {
      service: FacilityManagementService.uploadUsersFile,
      payloadExtras: {
        type: User === "provider-user" ? "provider" : "staff",
      },
      onRefresh: getUsers,
      asyncMessage: "Users import started successfully.",
      setIsImporting,
      setImportMessage,
      setImportResults,
      setOpenImportResultsDialog,
      setOpenImportInventoryDialog: setOpenImportUsersDialog,
    });
  };

  const addUsers = (data: any) => {
    try {
      if (defaultUsersDataRow?.userName) {
        const usersUpdatePayload = {
          payload: {
            firstName: data?.firstName,
            lastName: data?.lastName,
            email: data?.email,
            roleId: data?.role,
            facilityId: data?.workLocation,
            contactNumber: data?.contactNumber,
            gender: data?.gender,
            departmentIds: data?.department,
            status: data?.status,
          },
          id: defaultUsersDataRow?.id,
        };
        dispatch(patchFacilityUser(usersUpdatePayload));
      } else {
        const payload = {
          bsaId: data?.bsaId,
          firstName: data?.firstName,
          lastName: data?.lastName,
          email: data?.email,
          facilityId: data?.workLocation,
          contactNumber: data?.contactNumber,
          roleId: data?.role,
          gender: data?.gender,
          departmentIds: data?.department,
          status: data?.status,
          type: User === "provider-user" ? "provider" : "staff",
        };

        dispatch(addNewFacilityUser(payload));
      }
    } catch (error) {
      console.log(error);
    }
  };
  return (
    <WrapperCard
      customClasses="m-3 p-3 flex-1 min-h-0"
      customStyle={{ minWidth: deviceType !== "mobile" ? "400px" : "" }}
    >
      <div className="flex flex-col h-full gap-3">
        <div
          className={`flex ${deviceType === "mobile" ? "flex-col items-start gap-3" : "items-center"} justify-between w-full`}
        >
          <div className="flex items-center gap-3">
            <img
              className="cursor-pointer"
              src={rightDirectionBlackIcon}
              alt="back-arrow"
              style={{ height: "12.5px" }}
              onClick={() => {
                navigate("/settings");
              }}
              onKeyDown={(e) => {
                if (e.key === "Enter" || e.key === " ") {
                  navigate("/settings");
                }
              }}
              role="button"
              tabIndex={0}
            />
            <Heading
              title={`${user} User`}
              customStyle={{ color: "#1D1D1D" }}
            />
          </div>

          <div
            className={`flex ${deviceType === "mobile" ? "w-full justify-between" : ""} gap-3`}
          >
            <div style={{ maxWidth: "350px" }}>
              <SelectDropdown
                label=""
                name="facilityId"
                placeholderValue="Select Facility"
                displayEmpty={true}
                value={facilityId}
                options={facilityOptions}
                onChangeCb={(e) => {
                  setPageNumber(1);
                  setFacilityId(e.target.value);
                }}
              />
            </div>
            <div style={{ maxWidth: "350px" }}>
              <SelectDropdown
                label=""
                name="status"
                placeholderValue="All Status"
                displayEmpty={true}
                value={status}
                options={[
                  { label: "Active", value: "Active" },
                  { label: "In Active", value: "InActive" },
                ]}
                onChangeCb={(e) => {
                  setPageNumber(1);
                  setStatus(e.target.value);
                }}
              />
            </div>
            <div>
              <SearchSelectDropdown
                freeSolo={true}
                searchedValue={searchedValue}
                onSearchValueChangeCb={(e) => handleChange(e)}
                size="small"
                label="Search by name, email, contact number"
                fullWidth={deviceType === "mobile" ? "160px" : "300px"}
                startIcon={
                  <img
                    alt="search-icon"
                    src={searchIcon}
                    width={"18px"}
                    height={"18px"}
                  />
                }
              />
            </div>

            <Button
              startIcon={
                <img
                  src={DownloadIcon}
                  alt={"import"}
                  className="cursor-pointer w-[19px] h-[19px]"
                />
              }
              label="Import Users"
              variant="outlined"
              onClickCb={() => setOpenImportUsersDialog(true)}
              style={{
                paddingTop: "6px",
                paddingBottom: "6px",
                minWidth: "155px",
                backgroundColor: "white",
                border: "1px solid #005596",
                color: "#005596",
              }}
            ></Button>

            {selectedRowsForInvite.length > 0 && (
              <Button
                label={`Send Invitation${
                  selectedRowsForInvite.length > 1
                    ? ` (${selectedRowsForInvite.length})`
                    : ""
                }`}
                variant="contained"
                onClickCb={() => {
                  const ids = selectedRowsForInvite.map((r: any) => r?.id);
                  dispatch(sendFacilityUserBulkInvitation({ ids }));
                }}
                style={{
                  paddingTop: "6px",
                  paddingBottom: "6px",
                  minWidth: "155px",
                }}
              ></Button>
            )}

            <Button
              startIcon={
                <img
                  src={plusIcon}
                  alt={"search"}
                  className="cursor-pointer w-[19px] h-[19px]"
                />
              }
              label={`Add ${user}`}
              variant="contained"
              onClickCb={() => {
                setDefaultUsersDataRow({});
                setDialogState("add"); // Open add dialog
              }}
              style={{
                paddingTop: "6px",
                paddingBottom: "6px",
                minWidth: "155px",
              }}
            ></Button>
          </div>
        </div>
        <div style={{ overflow: "auto" }}>
          <Table
            columns={usersColumns}
            rows={usersRowData}
            selectProps={{
              isSelectAll: true,
              isSelectable: true,
              onSelectRowsCb: setSelectedRowsForInvite,
              selectIdentifier: "id",
              onSelectAll: () => {},
            }}
            paginationProps={{
              isPagination: true,
              page: pageNumber,
              totalPages: facilityUserList?.totalPages,
              totalCount: facilityUserList?.total,
              limit: rowPerPage,
              rowsPerPageOptions: [10, 25, 50],
              onPageChange: (page: any) => {
                setPageNumber(page);
              },
              handleChangeRowsPerPage: (rowPerPage: any) => {
                setRowPerPage(rowPerPage);
                setPageNumber(1);
              },
            }}
          />
        </div>
      </div>
      {/* ADD USERS DIALOG */}
      {dialogState && (
        <UsersScreenDialog
          defaultUsersData={defaultUsersDataRow}
          // On edit, scope the dialog to the edited user's OWN facility so Work
          // Location + Department prefill (and the department options load).
          // Falls back to the page filter for Add (no user row yet).
          facilityId={
            defaultUsersDataRow?.facilityId || selectedFacilityId?.value
          }
          user={user}
          isEdit={dialogState === "edit"} // Determine edit mode
          isOpen={!!dialogState} // Dialog is open if dialogState is not null          isOpen={openCodeDialog}
          handleClose={() => {
            setDialogState(null); // Close the dialog by setting to null
          }}
          handleData={(data) => {
            addUsers(data);
          }}
        />
      )}
      {openViewUserDialog && (
        <ViewUsersDialog
          user={user}
          // Show the viewed user's OWN facility (not the page filter, which is
          // empty on "All Facilities"). Falls back to the filter if absent.
          departmentName={
            defaultUsersDataRow?.facilityId || selectedFacilityId?.value
          }
          dialogHeading={`View ${user} Profile`}
          handleClose={() => setOpenViewUserDialog(false)}
          defaultDataForUser={defaultUsersDataRow}
          isOpen={openViewUserDialog}
        />
      )}

      {openConfirmationDialog && (
        <EventEHRConfirmationDialog
          alertTitle={`Delete ${user}`}
          alertDescription={`Are you sure you want to delete this ${user}? Please confirm to proceed.`}
          cancelButtonTitle="Cancel"
          submitButtonTitle="Delete"
          open={openConfirmationDialog}
          handleClose={(action) => {
            console.log(
              "Confirmation dialog handleClose called with action:",
              action
            );
            console.log("Current selectedUserId:", selectedUserId);
            console.log(
              "Current openConfirmationDialog:",
              openConfirmationDialog
            );
            if (action === "close") {
              setOpenConfirmationDialog(false);
              setSelectedUserId(null);
            } else if (action === "submit") {
              if (selectedUserId) {
                console.log("Deleting user with ID:", selectedUserId);
                const payload = {
                  id: selectedUserId,
                };
                console.log(
                  "Dispatching deleteFacilityUser with payload:",
                  payload
                );
                console.log(
                  "deleteFacilityUser action creator:",
                  deleteFacilityUser
                );
                const action = deleteFacilityUser(payload);
                console.log("Created action:", action);
                dispatch(action);
              } else {
                console.log("No selectedUserId found");
              }
            }
          }}
        />
      )}

      {openImportUsersDialog && (
        <ImportUsersDialog
          isOpen={openImportUsersDialog}
          handleClose={() => {
            setOpenImportUsersDialog(false);
            setImportMessage(null);
          }}
          handleImportUsersData={(formData: Record<string, unknown>) => {
            handleImportUsersData(formData);
          }}
          isImporting={isImporting}
          importMessage={importMessage}
        />
      )}

      <ImportResultsDialog
        isOpen={openImportResultsDialog}
        handleClose={() => {
          setOpenImportResultsDialog(false);
          setImportResults(null);
        }}
        results={importResults}
        invalidColumns={importUsersResultsColumns}
      />
    </WrapperCard>
  );
};

export default UsersScreen;
